import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Completed</h5>
      <h2>Certificates</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Google IT Support</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Technical Support Fundamentals</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>The Bits and Bytes of Computer Networking</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Operating Systems and You: Becoming a Power User</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>System Administration and IT Infrastructure Services</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>IT Security: Defense against the digital dark arts</p>
            </li>
          </ul>
        </article>
        {/* END OF Certificates */}

        <article className="service">
          <div className="service__head">
            <h3>Google Data Analytics</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Foundations: Data, Data, Everywhere</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Ask Questions to Make Data-Driven Decisions</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Prepare Data for Exploration</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Process Data from Dirty to Clean</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Analyze Data to Answer Questions</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Share Data Through the Art of Visualization</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Data Analysis with R Programming</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Google Data Analytics Capstone: Complete a Case Study</p>
            </li>
          </ul>
        </article>
        {/* END OF Google Data Analytics */}

        <article className="service">
          <div className="service__head">
            <h3>Other Courses</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Introduction To Python Programming</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Java Programming 2</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Java Programming 1</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Learn How to Become a User Experience Designer</p>
            </li>
          </ul>
        </article>
        {/* OTHER COURSES */}
      </div>
    </section>
  )
}

export default Services